import React, { useState, useRef } from 'react';

const imagenes = [
  "/imagenes/collage/1.jpeg",
  "/imagenes/collage/2.jpeg",
  "/imagenes/collage/3.jpeg",
  "/imagenes/collage/4.jpeg",
  "/imagenes/collage/5.jpeg",
  "/imagenes/collage/6.jpeg",
  "/imagenes/collage/7.jpeg",
  "/imagenes/collage/8.jpeg",
  "/imagenes/collage/9.jpeg",
  "/imagenes/collage/10.jpeg",
  "/imagenes/collage/11.jpeg",
  "/imagenes/collage/12.jpeg",
  "/imagenes/collage/13.jpeg",
  "/imagenes/collage/14.jpeg",
  "/imagenes/collage/15.jpeg",
  "/imagenes/collage/16.jpeg",
  "/imagenes/collage/17.jpeg",
  "/imagenes/collage/18.jpeg",
  "/imagenes/collage/19.jpeg",
  "/imagenes/collage/20.jpeg"
];

const Collage = () => {
  const [imagenActiva, setImagenActiva] = useState(0);
  const scrollRef = useRef(null);

  const seleccionarImagen = (index) => {
    setImagenActiva(index);

    const anchoMiniatura = 95;
    scrollRef.current.scrollTo({
      left: index * anchoMiniatura,
      behavior: 'smooth'
    });
  };

  return (
    <section className="collage-section">
      <div className="container">

        <div className="visor-collage">
          <img
            src={imagenes[imagenActiva]}
            alt="principal"
            className="imagen-principal"
          />

          <div className="miniaturas-internas" ref={scrollRef}>
            {imagenes.concat(imagenes).map((img, index) => (
              <div
                key={index}
                className={`miniatura ${imagenActiva === index % imagenes.length ? 'activa' : ''}`}
                onClick={() => seleccionarImagen(index % imagenes.length)}
              >
                <img src={img} alt={`mini-${index}`} />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Collage;